export function isBrowser() {
    return typeof window !== "undefined";
}
